var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInspekcja(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#d9d9d9",
    stroke: "#d9d9d9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#d1d1d1;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464,0H48C21.493,0,0,21.492,0,48v416c0,26.508,21.493,48,48,48h416c26.508,0,48-21.492,48-48V48 C512,21.492,490.508,0,464,0z M444.664,35c10.493,0,19,8.508,19,19s-8.507,19-19,19c-10.492,0-19-8.508-19-19 S434.172,35,444.664,35z M374.164,35c10.493,0,19,8.508,19,19s-8.507,19-19,19c-10.492,0-19-8.508-19-19S363.672,35,374.164,35z M303.664,35c10.493,0,19,8.508,19,19s-8.507,19-19,19c-10.492,0-19-8.508-19-19S293.172,35,303.664,35z M472,464 c0,4.406-3.586,8-8,8H48c-4.414,0-8-3.594-8-8V104h432V464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.234,267.39c2.875,0,5.195-2.328,5.195-5.202c0-14.93,12.133-27.078,27.064-27.078 c2.867,0,5.187-2.32,5.187-5.195s-2.32-5.188-5.187-5.188c-20.657,0-37.446,16.797-37.446,37.462 C194.047,265.062,196.375,267.39,199.234,267.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.875,365.102c18.711,0,36.18-5.438,50.89-14.844c11.728-7.484,21.704-17.468,29.18-29.202 c9.39-14.719,14.836-32.196,14.836-50.906c0-52.375-42.57-94.969-94.906-94.969c-18.711,0-36.18,5.438-50.89,14.828 c-11.734,7.484-21.703,17.469-29.18,29.211c-9.391,14.718-14.836,32.195-14.836,50.93 C147.969,322.485,190.547,365.102,242.875,365.102z M182.93,239.344c6.438-12.508,16.68-22.742,29.18-29.18 c9.234-4.766,19.688-7.461,30.766-7.461c37.164,0,67.398,30.25,67.398,67.446c0,11.07-2.703,21.531-7.452,30.766 c-6.438,12.515-16.68,22.766-29.172,29.203c-9.234,4.766-19.695,7.453-30.774,7.453c-37.156,0-67.406-30.25-67.406-67.422 C175.469,259.055,178.164,248.578,182.93,239.344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.688,362.164l41.976,41.875c4.031,4.016,9.297,6.039,14.57,6.039c5.29,0,10.571-2.023,14.602-6.039 c8.055-8.062,8.055-21.141,0-29.195l-41.976-41.875C327.055,344.375,317.07,354.352,305.688,362.164z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspekcja);
export default __webpack_public_path__ + "static/media/inspekcja.e8d07ff639bcd13cd7cb39c8f16d37e6.svg";
export { ForwardRef as ReactComponent };